import React, {useEffect, useState} from 'react';
import {Grid} from "@mui/material";
import PreviousNextButton from "../../../../../components/PreviousNextButton";
import {useIntl} from "react-intl";
import {RequestVisitorDto} from "../../../../../modules/vms/dto/RequestVisitorDto";
import dayjs from "dayjs";
import {Formats} from "../../../../../constants/Formats";
import {PlateNumberColor} from "../../../../../modules/vms/enums/PlateNumberColor";
import FormFieldSelect from "../../../../../components/FormFieldSelect";
import {VehicleType} from "../../../../../modules/vms/enums/VehicleType";
import FormFieldDate from "../../../../../components/FormFieldDate";
import {VehicleFuelType} from "../../../../../modules/vms/enums/VehicleFuelType";
import {VehicleEmissionStandard} from "../../../../../modules/vms/enums/VehicleEmissionStandard";

export type VehicleEnvironmentalProps = {
    onPrevious: () => void;
    onNext: (requestVisitor: RequestVisitorDto) => void;
    requestVisitor: RequestVisitorDto;
};
const VehicleEnvironmental: React.FC<VehicleEnvironmentalProps> = (props) => {
    const intl = useIntl();
    const [innerVisitor, setInnerVisitor] = useState<RequestVisitorDto>(props.requestVisitor);
    const [messageMap, setMessageMap] = useState(new Map<string, string>());

    useEffect(() => {
        setInnerVisitor(props.requestVisitor);
    }, [props.requestVisitor]);

    const handleChange = (name: string, value: any) => {
        setInnerVisitor({...innerVisitor, [name]: value});
    };

    const handlePrevious = () => {
        props.onPrevious();
    }

    const handleNext = () => {
        if (!validate()) {
            return;
        }
        props.onNext(innerVisitor);
    };

    const validate = () => {
        const newMessageMap = new Map<string, string>();
        if (innerVisitor.plateNumberColor === '') {
            newMessageMap.set('plateNumberColor', intl.formatMessage({id: 'VMS_REQUEST_VISITOR_PLATE_NUMBER_COLOR_REQUIRED'}));
        }
        if (innerVisitor.vehicleType === '') {
            newMessageMap.set('vehicleType', intl.formatMessage({id: 'VMS_REQUEST_VISITOR_VEHICLE_TYPE_REQUIRED'}));
        }
        if (innerVisitor.vehicleRegistrationDate === '') {
            newMessageMap.set('vehicleRegistrationDate', intl.formatMessage({id: 'VMS_REQUEST_VISITOR_VEHICLE_REGISTRATION_DATE_REQUIRED'}));
        }
        if (innerVisitor.vehicleFuelType === '') {
            newMessageMap.set('vehicleFuelType', intl.formatMessage({id: 'VMS_REQUEST_VISITOR_VEHICLE_FUEL_TYPE_REQUIRED'}));
        }
        if (innerVisitor.vehicleEmissionStandard === '') {
            newMessageMap.set('vehicleEmissionStandard', intl.formatMessage({id: 'VMS_REQUEST_VISITOR_VEHICLE_EMISSION_STANDARD_REQUIRED'}));
        }

        setMessageMap(newMessageMap);
        return newMessageMap.size <= 0;
    };

    return (
        <div>
            <Grid container spacing={2} style={{height: '50vh'}}>
                <Grid item xs={6}>
                    <FormFieldSelect label={intl.formatMessage({id: "VMS_REQUEST_VISITOR_PLATE_NUMBER_COLOR"})}
                                     value={innerVisitor.plateNumberColor}
                                     required={true} errorText={messageMap.get("plateNumberColor")}
                                     onChange={(value) => {
                                         handleChange("plateNumberColor", value)
                                     }}
                                     items={PlateNumberColor.List.map((item) => {
                                         return {label: intl.formatMessage({id: item.label}), value: item.value}
                                     })}/>
                </Grid>
                <Grid item xs={6}>
                    <FormFieldSelect label={intl.formatMessage({id: "VMS_REQUEST_VISITOR_VEHICLE_TYPE"})}
                                     value={innerVisitor.vehicleType}
                                     required={true} errorText={messageMap.get("vehicleType")}
                                     onChange={(value) => {
                                         handleChange("vehicleType", value)
                                     }}
                                     items={VehicleType.List.map((item) => {
                                         return {label: intl.formatMessage({id: item.label}), value: item.value}
                                     })}/>
                </Grid>
                <Grid item xs={6}>
                    <FormFieldDate label={intl.formatMessage({id: "VMS_REQUEST_VISITOR_VEHICLE_REGISTRATION_DATE"})}
                                   value={dayjs(innerVisitor.vehicleRegistrationDate, Formats.DATE_SIMPLE)}
                                   required={true} errorText={messageMap.get("vehicleRegistrationDate")}
                                   onChange={(value) => handleChange("vehicleRegistrationDate", value)}/>

                </Grid>
                <Grid item xs={6}>
                    <FormFieldSelect label={intl.formatMessage({id: "VMS_REQUEST_VISITOR_VEHICLE_FUEL_TYPE"})}
                                     value={innerVisitor.vehicleFuelType}
                                     required={true} errorText={messageMap.get("vehicleFuelType")}
                                     onChange={(value) => {
                                         handleChange("vehicleFuelType", value)
                                     }}
                                     items={VehicleFuelType.List.map((item) => {
                                         return {label: intl.formatMessage({id: item.label}), value: item.value}
                                     })}/>
                </Grid>
                <Grid item xs={6}>
                    <FormFieldSelect label={intl.formatMessage({id: "VMS_REQUEST_VISITOR_VEHICLE_EMISSION_STANDARD"})}
                                     value={innerVisitor.vehicleEmissionStandard}
                                     required={true} errorText={messageMap.get("vehicleEmissionStandard")}
                                     onChange={(value) => {
                                         handleChange("vehicleEmissionStandard", value)
                                     }}
                                     items={VehicleEmissionStandard.List.map((item) => {
                                         return {label: intl.formatMessage({id: item.label}), value: item.value}
                                     })}/>
                </Grid>
            </Grid>
            <Grid>
                <PreviousNextButton onPrevious={handlePrevious} onNext={handleNext}/>
            </Grid>
        </div>
    );
};

export default VehicleEnvironmental;
